<template>
  <transition name="fade">
    <div
      v-if="swState.updateAvailable"
      class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-sky-600 text-white shadow-lg rounded-lg px-5 py-3 flex items-center gap-4"
    >
      <div class="flex flex-col">
        <span class="font-semibold">Nuova versione disponibile</span>
        <span v-if="swState.newVersion" class="text-xs opacity-80">Versione: {{ swState.newVersion }}</span>
      </div>
      <button
        @click="refresh"
        class="bg-white text-sky-700 font-medium px-3 py-1 rounded hover:bg-sky-100 transition"
      >Aggiorna</button>
      <button
        @click="dismiss"
        class="text-white/80 hover:text-white text-sm"
      >Chiudi</button>
    </div>
  </transition>
</template>

<script setup>
const nuxtApp = useNuxtApp();
const swState = nuxtApp.$swUpdateState || inject('swUpdateState');
const applyUpdate = nuxtApp.$applySwUpdate || inject('applySwUpdate');

const refresh = () => {
  applyUpdate?.();
};

const dismiss = () => {
  if (swState) swState.updateAvailable = false;
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity .25s, transform .25s; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(10px); }
</style>
